
import { cleanupText } from '@/utils/report';
import Heading from '@/components/ui/heading';

type ReportTitleProps = {
  title: string | null;
};

const ReportTitle = ({ title }: ReportTitleProps) => {
  if (!title) return null;
  
  // Clean up any HTML tags in the title
  const cleanTitle = title.replace(/<\/?strong>/g, '');
  
  return (
    <Heading level={1}>
      {cleanupText(cleanTitle)}
    </Heading>
  );
};

export default ReportTitle;
